import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-h7-bold",
  "use": "icon-h7-bold-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol viewBox=\"0 0 20 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-h7-bold\">\n<path d=\"M1.12 5.576V17H2.992V11.944H8.784V17H10.656V5.576H8.784V10.344H2.992V5.576H1.12Z\" fill=\"#323232\" />\n<path d=\"M14.3 9.87709V10.9371H17.95L15.39 17.0171H16.63L19.13 10.8171V9.87709H14.3Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol